import { useState } from "react";
import { FaChevronDown, FaChevronUp, FaDiscord, FaFacebook } from "react-icons/fa";

const faqs = [
  {
    question: "Why join GUBCPC?",
    answer:
      "You improve problem-solving skills, prepare for ICPC/IUPC, and learn in a collaborative environment.",
  },
  {
    question: "Do I need prior experience?",
    answer: "No. We welcome complete beginners and provide guided learning tracks.",
  },
  {
    question: "Which language should I use?",
    answer: "Most members use C++, Python, or Java. Start with whichever you are comfortable with.",
  },
  {
    question: "Is there any fee?",
    answer: "No, participation is free for interested students.",
  },
  {
    question: "How can I stay updated?",
    answer: "Follow our Facebook page and join Discord for regular announcements.",
  },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="home-section">
      <div className="home-container">
        <div className="grid home-stagger-grid gap-5 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="home-card-strong sticky top-24 p-6">
              <span className="section-kicker">FAQ</span>
              <h2 className="home-title mt-4 text-2xl font-bold sm:text-4xl">
                Questions <span className="home-accent-gradient">new members ask</span>
              </h2>
              <p className="mt-3 text-sm leading-7 home-muted">
                Quick clarifications about joining, learning path, and communication channels.
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                <a href="https://discord.gg/6xhH5vQQ" target="_blank" rel="noreferrer" className="home-btn-secondary inline-flex items-center gap-2 px-4 py-2 text-sm">
                  <FaDiscord className="home-accent" /> Discord
                </a>
                <a href="https://facebook.com/gubcpa" target="_blank" rel="noreferrer" className="home-btn-secondary inline-flex items-center gap-2 px-4 py-2 text-sm">
                  <FaFacebook className="home-accent" /> Facebook
                </a>
              </div>
            </div>
          </div>

          <div className="space-y-3 lg:col-span-8">
            {faqs.map((faq, index) => {
              const open = activeIndex === index;
              return (
                <article key={faq.question} className="home-card overflow-hidden">
                  <button
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    onClick={() => setActiveIndex(open ? -1 : index)}
                  >
                    <span className="font-semibold">{faq.question}</span>
                    {open ? <FaChevronUp className="shrink-0 home-accent" /> : <FaChevronDown className="shrink-0 home-accent" />}
                  </button>
                  {open && (
                    <p className="border-t px-5 py-4 text-sm leading-7 home-muted" style={{ borderColor: "var(--border)" }}>
                      {faq.answer}
                    </p>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
